import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {LocalStorageService} from '../../../services/local-storage.service';
import {CommonService} from '../../../services/common.service';
import {LookupOptionsData} from '../../jurisdiction.domain';
import {AllDropdownKeys} from '../../jurisdiction.constants';
import {FacilitiesFormService} from '../../facilities-form/facilities-form.service';
import {Subscription} from 'rxjs';
import {FiringSystemDataObject} from '../../facilities-form/facilities-form.domain';

@Component({
  selector: 'app-information-on-construction',
  templateUrl: './information-on-construction.component.html',
  styleUrls: ['./information-on-construction.component.scss']
})
export class InformationOnConstructionComponent implements OnInit {
  @Input() firingSystemData: FiringSystemDataObject;
  @Input() isReadOnly: boolean = false;

  infoOnConstructionFG: FormGroup;
  formSubscription: Subscription;
  constructionChimney: Array<LookupOptionsData> = [];

  constructor(private formBuilder: FormBuilder,
              private localStorageService: LocalStorageService,
              private commonService: CommonService,
              private facilitiesFormService: FacilitiesFormService,
  ) {
  }

  ngOnInit(): void {
    const constructionSpec = AllDropdownKeys.ConstructionSpec;
    this.constructionChimney = this.commonService.getDropdownData(constructionSpec);
    this.prepareFormGroup();
    this.facilitiesFormService.registerForComponentFormUpdate.next({
      component: 'construction',
      formData: this.infoOnConstructionFG,
    });
    this.facilitiesFormService.registerForActionOnFormSubmit.subscribe(
      (value: boolean) => {
        if (value) {
          this.resetData();
        }
      });
  }

  prepareFormGroup(): void {
    this.infoOnConstructionFG = this.formBuilder.group({
      constructionChimneySweep: [{
        value: this.firingSystemData?.constructionChimneySweep,
        disabled: this.isReadOnly
      }, [Validators.required]],
      systemId: [this.firingSystemData?.systemId || '']
    });
    this.formSubscription = this.infoOnConstructionFG.valueChanges.subscribe((x) => {
      this.facilitiesFormService.registerForComponentFormUpdate.next({
        component: 'construction',
        formData: this.infoOnConstructionFG,
      });
    });
  }

  getSkChimSweepLabel(label: string) {
    return `lookup.sk_construction_spec.options.${label}.name`;
  }

  private resetData(): void {
    this.formSubscription.unsubscribe();
    this.prepareFormGroup();
  }
}
